

const menuItems = document.querySelectorAll('.menu-item');
let currentCategory = null;
const queryString = window.location.search.slice(1);

document.addEventListener('alpine:init', () => {
    Alpine.store('ui', {
        openSideMenu: window.innerWidth >= 1024,
    });

    // Optional: responsive listener
    window.addEventListener('resize', () => {
        Alpine.store('ui').openSideMenu = window.innerWidth >= 1024;
    });
});

/*OpenMenu(queryString);*/
fetchCountFilters(queryString);

const mainMenu = document.querySelector('.menu');

document.querySelector('.side-menu-close').addEventListener('click',function (){
    Alpine.store('ui').openSideMenu = false;
});

/*
function OpenMenu(queryString) {
    document.addEventListener("alpine:init", () => {
        const urlParams = new URLSearchParams(window.location.search);
        const category = urlParams.get("category");
        const subcategories = (urlParams.get("subcategory") || "")
            .split(",")
            .map(s => s.trim())
            .filter(Boolean);

        console.log(Alpine);
    });

}
*/

const filtersTitles = document.querySelectorAll('.filters-section .dropdown-btn.filter-name');
const FiltersSectionsBtn = document.querySelectorAll('.filter-container .dropdown-btn.filter-name');

FiltersSectionsBtn.forEach((elem) => {
   elem.addEventListener('click', function (){
      if(elem.getAttribute('aria-expanded') === "true"){
          const childs = elem.nextElementSibling.querySelectorAll('.sub-item.filter-item');
          childs.forEach((child)=>{
                  child.classList.remove('active');
              });
          BuildQueryString();
      }
   });
});

menuItems.forEach((elem) => {
    elem.addEventListener('click', function (e) {
            document.querySelector('.side-menu').classList.add('is-loading');
            e.preventDefault();
            const dataType = elem.parentElement.dataset.type ? elem.parentElement.dataset.type : "categories";
            if (dataType === 'filters' || dataType === 'subcategory') {
                if (elem.classList.contains('active')) {
                    elem.classList.remove('active');
                    const filterType = elem.closest('.filter-container').querySelector('.filter-name').dataset.slug;
                } else {
                    elem.classList.add('active');
                }
                BuildQueryString();
            }else if(dataType == 'categories'){
                elem.classList.toggle('active');
                const activeCategory = elem.parentElement.querySelector("button").dataset.slug
                if(activeCategory !== currentCategory){
                    const oldCategoryContainer = document.querySelector('.filter-container button[data-slug="'+currentCategory+'"]')?.nextElementSibling;
                    const oldSubcategories = oldCategoryContainer?.querySelectorAll('.menu-item');
                    oldSubcategories?.forEach((elem)=>{
                       elem.classList.remove('active');
                    });

                    // Remove all active filter

                    const activeFilters = document.querySelectorAll('.filters-section .sub-item.menu-item.active');
                    activeFilters.forEach((elem)=>{
                       elem.classList.remove('active');
                    });

                    const oldCategoryButton = document.querySelector('.filter-container button[data-slug="'+currentCategory+'"]');
                    oldCategoryButton?.classList.remove('active');

                    const activeCategoryContainer = document.querySelector('.filter-container button[data-slug="'+activeCategory+'"]').nextElementSibling;
                    const activeCategories = activeCategoryContainer?.querySelectorAll('.menu-item');

                    activeCategories?.forEach((elem)=>{
                    });

                    currentCategory = activeCategory;
                }else{
                    const activeSubCategories = document.querySelectorAll('.categories-section .dropdown-content[data-uid="'+activeCategory+'"] .sub-item');
                    activeSubCategories.forEach((elem)=>{
                        elem.classList.remove('active');
                    });
                }
                BuildQueryString();
            }
        });
});

async function hideUnnecessaryFilters() {

    document.querySelectorAll('.filters-section .filter-container').forEach(content => {
        content.classList.remove('empty');
    });


    document.querySelectorAll('.filters-section .filter-container').forEach(container => {
        const enabledItems = container.querySelectorAll('.dropdown-content > .sub-item:not(.disabled)');
        if (enabledItems.length > 0) {
            enabledItems.forEach(item => item.classList.remove('last-enabled'));
            enabledItems[enabledItems.length - 1].classList.add('last-enabled');
        }

        if(enabledItems.length === 0) {
            container.querySelector('.dropdown-content').parentElement.classList.add('empty');
        }
    });
}

async function fetchCountFilters(queryString) {

    const domain = window.location.origin;
    const apiUrl = domain + '/api/countfilters/?' + queryString;

    try {
        const response = await fetch(apiUrl);

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        document.querySelector('.side-menu').classList.remove('is-loading');

        if (data) {
            const currentCat = data['selectedCategory'];
            const subCats = data['subcategoryCount'];
            const filters = data['subFiltersCount'];
            const allCat = data['categoryCount'];
            const currentCatCount = data['currentCatCount'];

            console.log(subCats);

            if(currentCatCount){
                const currentCatItem = document.querySelector(`.current-category`);
                if (currentCatItem) {
                    const filterCountDiv = currentCatItem.querySelector('.filter-count');
                    if (filterCountDiv) {
                        filterCountDiv.innerText = currentCatCount.count;
                    }
                }
            }
            if (allCat) {
                Object.values(allCat).forEach(cat => {
                    const filterItem = document.querySelector(`.dropdown-btn[data-field="category"][data-slug="${cat.id}"]`);
                    if (filterItem) {
                        const filterCountDiv = filterItem.querySelector('.filter-count');
                        if (filterCountDiv) {
                            filterCountDiv.innerText = cat['count'];
                        }
                    }
                });
            }
            if (subCats) {
                Object.values(subCats).forEach(subcat => {
                    const filterItem = document.querySelector(`.dropdown-content[data-uid="${currentCat}"] .filter-item[data-slug="${subcat.id}"]`);
                    if (filterItem) {
                        const filterCountDiv = filterItem.querySelector('.filter-count');
                        if (filterCountDiv) {
                            filterCountDiv.innerText = subcat['count'];
                        }
                    }
                });
            }
            if(filters){
                Object.values(filters).forEach(filter => {
                    /*console.log(`Items dans ${filter.name} (${filter.id}):${filter['count']}`);*/
                    const filterItem = document.querySelector(`.dropdown-content[data-type="filters"] .filter-item[data-slug="${filter.id}"]`);
                    if (filterItem) {
                        const filterCountDiv = filterItem.querySelector('.filter-count');
                        if (filterCountDiv) {
                            filterCountDiv.innerText = filter['count'];
                        }
                        if(filter['count'] === 0){
                            filterItem.classList.add('disabled');
                            filterItem.classList.remove('active');
                        }else{
                            filterItem.classList.remove('disabled');
                        }
                    }
                });

                hideUnnecessaryFilters();
            }
        }

        return data;

    } catch (error) {
        console.error('Error fetching data:', error);
        return null;
    }
}


const BuildQueryString = () => {
    const baseUrl = `${window.location.origin}${window.location.pathname}`;
    const activeFilters = document.querySelectorAll('.menu-item.active');
    const activeFiltersArr = {};

    activeFilters.forEach((elem) => {
        const filterTitle = elem.dataset.field;
        let filterValue;
        if(filterTitle === 'category' || filterTitle === 'subcategory') {
             filterValue = elem.lastElementChild && elem.lastElementChild.tagName === "A" ? elem.querySelector('a').parentElement.dataset.slug : elem.dataset.slug;
        }else{
             filterValue = elem.lastElementChild && elem.lastElementChild.tagName === "A" ? elem.querySelector('a').innerHTML: elem.dataset.innerHTML;
        }

        if (filterTitle === 'category') {
            activeFiltersArr[filterTitle] = [filterValue];
        } else {
            if (activeFiltersArr[filterTitle]) {
                activeFiltersArr[filterTitle].push(filterValue);
            } else {
                activeFiltersArr[filterTitle] = [filterValue];
            }
        }
    });

    var queryString;
    if(activeFilters){
         queryString = Object.keys(activeFiltersArr)
            .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(activeFiltersArr[key])}`)
            .join('&');
    }else{
         queryString = null;
    }

    const queryUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;
    fetchCountFilters(queryString);
    window.swup.navigate(queryUrl);

}
